import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from '@env';
import { mockLiveDataFor } from './mock-live-data';

const LIVE_PATH = /\/api\/(?:campaigns|fundraisers|teams)\/([^/]+)\/live$/;

/**
 * Functional HTTP interceptor that returns canned live data for the
 * /api/campaigns/:id/live and /api/fundraisers/:id/live endpoints when
 * environment.mockLiveFragments is true.
 *
 * Production builds set mockLiveFragments=false so this interceptor
 * never short-circuits — real requests flow through to the backend.
 */
export const liveFragmentMockInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.mockLiveFragments) return next(req);

  const match = req.url.match(LIVE_PATH);
  if (!match) return next(req);

  const id = match[1];
  const body = mockLiveDataFor(id);

  return of(new HttpResponse({ status: 200, body })).pipe(delay(50));
};
